import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!BACKEND_URL) {
  console.warn("REACT_APP_BACKEND_URL is not set");
}

export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// ─── Assumed-tenant header ─────────────────────────────────
// Platform admins can pin an X-Tenant-Id header to "view as" another tenant
// without leaving their own session. Backend `auth.resolve_tenant()` only
// honours this header for users with the `platform_administrator` role.
//
// Storage lives in localStorage under `altara.assumed_tenant_id`. Set to
// empty string / removed to revert to the admin's own tenant.
export const ASSUMED_TENANT_KEY = "altara.assumed_tenant_id";

export function getAssumedTenant() {
  try { return localStorage.getItem(ASSUMED_TENANT_KEY) || ""; }
  catch { return ""; }
}

export function setAssumedTenant(tenantId) {
  try {
    if (tenantId) localStorage.setItem(ASSUMED_TENANT_KEY, tenantId);
    else localStorage.removeItem(ASSUMED_TENANT_KEY);
    // Broadcast so components can re-fetch without a page reload
    window.dispatchEvent(new CustomEvent("altara:assumed-tenant-changed", { detail: { tenantId } }));
  } catch { /* ignore quota */ }
}

api.interceptors.request.use((config) => {
  const t = getAssumedTenant();
  if (t) {
    config.headers = config.headers || {};
    config.headers["X-Tenant-Id"] = t;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => Promise.reject(err),
);

export default api;
